import { UnansweredTableItem } from './FeedbackTable';

// 按组分组标签的函数
export const groupTagsByGroup = (tags: UnansweredTableItem['tags']) => {
  if (!tags || tags.length === 0) return {};

  return tags.reduce((groups, tag) => {
    const groupId = tag.group.id;
    if (!groups[groupId]) {
      groups[groupId] = {
        groupName: tag.group.name,
        tags: [],
      };
    }
    groups[groupId].tags.push(tag);
    return groups;
  }, {} as Record<string, { groupName: string; tags: typeof tags }>);
};
